/**
 * Parses a quantity value that may be a number or a string with comma
 * thousand-separators (e.g. "1,500.75") or plain decimal strings.
 * Returns 0 for undefined / null / invalid values.
 */
export function parseQuantity(value: string | number | undefined | null): number {
  if (value === null || value === undefined || value === '') return 0;
  if (typeof value === 'number') return isNaN(value) ? 0 : value;
  const cleaned = String(value).replace(/,/g, '');
  const parsed = parseFloat(cleaned);
  return isNaN(parsed) ? 0 : parsed;
}
